import styled from "styled-components";

export const PreviewImage = styled.img<{ isUnlocked: boolean }>`
	${props => (props.isUnlocked ? `cursor: pointer;` : ``)}
`;
